import React from "react";
import {
  JpegAfter1,
  JpegAfter2,
  JpegBefore2,
  JpegBrefore1,
  PngFooterback,
  PngLogo,
  WebpHomesectionbackground,
} from "../assets";
import { Facebook, Instagram, Linkedin, Twitter } from "react-feather";
import { Link } from "react-router-dom";

export default function Gallery() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      {" "}
      <section className="about__hero">
        <img
          loading="lazy"
          className="about__hero__img"
          src={WebpHomesectionbackground}
          alt="Knights Home Service"
        />
        <div className="about__hero__content">
          <div className="about__hero__content__heading">
            Our Services – Quality You Can Trust
          </div>
          <div className="about__hero__content__text">
            Knights Home Service offers a wide range of professional cleaning
            solutions, including pressure washing, house washing, window
            cleaning, roof cleaning, and gutter cleaning. We use advanced
            techniques and eco-friendly products to deliver exceptional results
            for your home or business. Let us help you maintain a clean,
            beautiful, and well-protected property!
          </div>
        </div>
      </section>
      <section className="County">
        <div className="County__content">
          <div className="County__content__left">
            <div className="County__content__left__heading">
              How to Clean Windows in Orange County
            </div>
            <div className="County__content__left__info">
              We all know how alluring the shine of a spotless glass window can
              be, whether in a residential or commercial setting, and no one
              would want to miss out. The beauty of the sunlight streaming in
              through a clean window is an everyday luxury that can’t be
              understated. Looking out the window or enjoying the gentle passage
              of Orange County air through your window, either if you are home
              or at your workplace, it’s surely not something you want to
              obstruct. So, the question becomes: how do you ensure the best
              window maintenance for that crisp, clear view? Enter The Pressure
              Guys, a reliable window cleaning company that has the answers to
              your questions. This essay gives you a guide on how to clean both
              the interior and the exterior of your windows, with a focus on the
              dedicated work of our skilled employees.
            </div>
            <div className="County__content__left__info">
              One major factor that you must first consider is the day’s choice.
              If the day is too sunny, it will affect the cleaning process as
              the water and detergent mix may evaporate too rapidly. That’s
              where our window washing Orange County service shines – you can
              trust Knights Home Service to select a perfect day for the
              cleaning. Instead of going through the tough exercise of cleaning
              or wondering which day would be perfect, make one choice that
              takes care of everything else—hire Knights Home Service. Their
              team of highly trained professionals uses state-of-the-art
              equipment, like their squeegee, and eco-friendly cleaning
              solutions to ensure that every window is sparkling clean, leaving
              your home or business looking its best.
            </div>
            <div className="County__content__left__info">
              Also, our employees are experts in window washing Orange County,
              which might be a valuable addition to our window cleaning service.
              With their expertise, solid work ethic, and attention to detail,
              you can trust Knights Home Service to meet your needs, seen
              through the positive reviews shared by satisfied customers.
              Whether you need regular maintenance or one-time window washers
              Orange County, Knights Home Service have got you covered.
            </div>
          </div>
          <div className="County__content__right">
            <div className="County__content__right__img">
              <img src={JpegBrefore1} alt="img" />
            </div>
          </div>
        </div>
        <div className="County__content">
          <div className="County__content__left">
            <div className="County__content__left__info__content">
              <div className="County__content__left__info__content__heading">
                Choose a Cool, Cloudy Day
              </div>
              <div className="County__content__left__info__content__info">
                There's no denying that the implements used for cleaning make a
                big difference. Brushes, sponges, and squeegees are staples.
                But, to get that sparkling clean, having a mix of water and
                detergent is also essential. Knights Home Service, the best
                window cleaner Orange County company, offer pressure washing
                services as well as regular window cleaning. Here, we ensure
                your window frames, screens, and glass surfaces are spotless.
                <br />
                <br />
                Our team of skilled window cleaning Orange County professionals
                uses eco-friendly cleaning solutions and techniques that include
                power washing to provide a thorough and streak-free cleaning
                experience. With our attention to detail, commitment to customer
                service, and extensive effort to maintain client satisfaction,
                you can trust Knights Home Service for all your Orange County
                window cleaning needs.
              </div>
              <div className="County__content__left__info__content__heading">
                Get the Cleaning Materials Ready
              </div>
              <div className="County__content__left__info__content__info">
                When cleaning, it's essential to stem the tide of spills. Laying
                a large towel down is a critical part of window cleaning,
                helping to prevent dirt and dust. This strategy, like using a
                ladder to reach higher windows, can be overlooked when trying to
                tackle it yourself or when you hire a less experienced service.
                The potential consequences include accidents and an
                unnecessarily lengthened cleaning process that results in
                fatigue.
                <br />
                <br />
                Knights Home Service, with their customer-focused mindset, never
                forget to do the needful. Their team of expert window cleaners
                uses state-of-the-art equipment and techniques, such as pressure
                washing, to ensure that every window in Orange County is left
                sparkling clean, removing all dirt, grime, and streaks with the
                utmost precision. Their efficient and thorough approach
                guarantees that you receive reliable and quality customer
                service, results appreciated by their customers as seen in their
                positive reviews. Whether you're in need of Orange County window
                cleaning services or professional Orange County window washing,
                Knights Home Service are the team to trust for superior results.
              </div>
              <div className="County__content__left__info__content__heading">
                Catch Spills with a Laid Towel
              </div>
              <div className="County__content__left__info__content__info">
                In addition to laying a large towel to catch spills, there are
                other pre-cleaning exercises to carry out. These preparatory
                tasks make the cleaning fast and effective, living up to Knights
                Home Service' well-known culture of efficiency, upheld at every
                single job site across Orange County. Their reliable employees
                set the standard for other window cleaning companies, thanks to
                their detailed work and exceptional customer service. With a
                team of experienced professionals and state-of-the-art
                equipment, Orange County Window Cleaning guarantees sparkling
                clean windows, leaving every customer satisfied and their homes
                or businesses looking their best. Whether it's a residential
                property or a commercial building, their meticulous attention to
                detail and commitment to serving their clients is what sets them
                apart.
              </div>
              <div className="County__content__left__info__content__heading">
                Fulfill all Pre-Cleaning Needs
              </div>
              <div className="County__content__left__info__content__info">
                The process of cleaning gives attention to details, like
                cleaning from the interior to the exterior. More than this is
                how the cleaning solution, expertly applied by a seasoned window
                cleaner, is squeezed off the windows, leaving them crystal clear
                and streak-free. Professional window cleaners in Orange County
                are experts in using the right tools and techniques, including
                power washing, to ensure a thorough and efficient cleaning
                process. If one end is done horizontally, the other is better
                done vertically. This method aids in identifying streaks,
                ensuring no spot is overlooked. The professional and creative
                approach is what sets Knights Home Service apart in Orange
                County.
              </div>
              <div className="County__content__left__info__content__heading">
                Clean Inside-Out
              </div>
              <div className="County__content__left__info__content__info">
                When cleaning, attention must be paid to how the process is
                carried out. One of such ways to avoid this is cleaning
                inside-out. More than this is the manner the cleaning solution
                is applied and sprayed. If one end is done horizontally, the
                other is better done vertically. Why? This helps in identifying
                streaks in case there is any. There are more professionals of
                Knights Home Service can do. We are creative in what we do like
                no one else in Orange County.
                <br />
                <br />
                Why not hand over the task of window cleaning to the best in
                Orange County? Knights Home Service offer high-quality window
                cleaning services and pressure washing services that are both
                effective and affordable, designed to meet your needs. Their
                work and dedication guarantee a reliable service, a claim
                supported by numerous reviews from satisfied customers.
                <br />
              </div>
              <div className="County__content__left__info__content__info">
                Call Knights Home Service today in Orange County on 03131231 to
                schedule your appointment or get your free estimate. Their team
                of experienced window cleaners is ready to help. Trust us, your
                clean windows will make all the difference!
              </div>
              <button
                title="Get A Free Quote Today"
                // onClick={() => {
                //   navigate("/who-we-are");
                //   scrollToTop();
                // }}
                className="Homesection__content__overlay__button button__margin"
              >
                Get A Free Quote Today
              </button>
            </div>
          </div>
          <div className="County__content__right">
            <div className="County__content__right__img">
              <img src={JpegAfter1} alt="img" />
              <img src={JpegBefore2} alt="img" />{" "}
              <img src={JpegAfter2} alt="img" />
            </div>
          </div>
        </div>
      </section>
      <footer className="Footer">
        <div className="footerbackground">
          <img loading="lazy" src={PngFooterback} alt="" />
        </div>
        <div className="footer__overlay">
          <div className="Footer__content">
            <div className="Footer__content__left">
              <div
                className="Footer__content__left__logo"
                title="Knights Home Service"
              >
                <img src={PngLogo} alt="img" />
              </div>
              <div className="Footer__content__left__logo__info">
                Our company offers professional home appliance repair services
                and top-notch cleaning services. Our goal is to provide our
                customers with excellent service and satisfaction, which is why
                we offer affordable prices and flexible scheduling options.
              </div>
            </div>
            <div className="Footer__content__mid">
              <div className="Footer__content__mid__content">
                <div className="Footer__content__mid__content__left">
                  <div className="Footer__content__mid__content__left__heading">
                    Quick Links
                  </div>
                  <div className="Footer__content__mid__content__left__links">
                    <Link to="#" onClick={scrollToTop}>
                      Home
                    </Link>
                    <Link to="#" onClick={scrollToTop}>
                      About Us
                    </Link>

                    <Link to="#" onClick={scrollToTop}>
                      Contact Us
                    </Link>
                  </div>
                </div>
                <div className="Footer__content__mid__content__left">
                  <div className="Footer__content__mid__content__left__heading">
                    Company
                  </div>
                  <div className="Footer__content__mid__content__left__links">
                    <Link onClick={scrollToTop} to="#">
                      Privacy Statement
                    </Link>
                    <Link onClick={scrollToTop} to="#">
                      Terms of Use
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="Footer__content__right">
              <div className="Footer__content__mid__content__left__heading">
                Stay Updated with us
              </div>
              <div className="Footer__content__right__input__name">
                Your Email
              </div>
              <div className="Footer__content__right__input__button">
                <input
                  className="Footer__content__right__input__button__email"
                  placeholder="Enter your Email"
                  type="email"
                  name="email"
                  id="email"
                />
                <button title="Subscribe">Submit</button>
              </div>
              <div className="Footer__content__right__all__links">
                <a target="_blank" href="https://www.facebook.com/">
                  <Facebook className="Footer__content__right__all__links__link" />
                </a>
                <a target="_blank" href="https://www.instagram.com/">
                  {" "}
                  <Instagram className="Footer__content__right__all__links__link" />
                </a>
                <a target="_blank" href="https://twitter.com/">
                  <Twitter className="Footer__content__right__all__links__link" />
                </a>

                <a target="_blank" href="https://pk.linkedin.com/">
                  {" "}
                  <Linkedin className="Footer__content__right__all__links__link" />
                </a>
              </div>
            </div>
          </div>
          <div className="Footer__bottom">
            <span className="line"> </span>
            <div className="Footer__bottom__heading">
              Copyright © 2024 by Knights Home Service Home appliance repair
              service
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
